<template>
  <article class="prose prose--app raw-container max-w-none">
    <div v-html="rawText" />
  </article>
</template>

<script setup lang="ts">
interface Props {
  rawText: string
}

defineProps<Props>()
</script>
